import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { Loader } from "@/components/Loader";
import { TravelDetails } from "@/components/sections/TravelDetails";
import { Hotels } from "@/components/sections/Hotels";
import { Itinerary } from "@/components/sections/Itinerary";
import { UmrahGuide } from "@/components/sections/UmrahGuide";
import { JanazahSection } from "@/components/sections/JanazahSection";
import { Documents } from "@/components/sections/Documents";
import { MapsNav } from "@/components/sections/MapsNav";
import { FoodShopping } from "@/components/sections/FoodShopping";
import { Faq } from "@/components/sections/Faq";
import { Support } from "@/components/sections/Support";
import { QuranReader } from "@/components/sections/QuranReader";
import { DuaLibrary } from "@/components/sections/DuaLibrary";

export default function SectionPage() {
  const { id } = useParams();
  const { content, loading } = useContent();

  if (loading || !content) return <Loader />;

  switch (id) {
    case "travel":
      return <TravelDetails data={content.travel} />;
    case "hotels":
      return <Hotels data={content.hotels} />;
    case "itinerary":
      return <Itinerary data={content.itinerary} />;
    case "umrah":
      return <UmrahGuide data={content.umrahGuide} />;
    case "janazah":
      return <JanazahSection />;
    case "documents":
      return <Documents data={content.documents} />;
    case "maps":
      return <MapsNav data={content.maps} />;
    case "food":
      return <FoodShopping data={content.food} />;
    case "faq":
      return <Faq data={content.faqs} />;
    case "support":
      return <Support data={content.support} />;
    case "quran":
      return <QuranReader />;
    case "dua":
      return <DuaLibrary />;
    default:
      return <Navigate to="/" replace />;
  }
}
